import { render, staticRenderFns } from "./EmptySearchState.vue?vue&type=template&id=b964897e&scoped=true&"
import script from "./EmptySearchState.vue?vue&type=script&lang=ts&"
export * from "./EmptySearchState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b964897e",
  null
  
)

export default component.exports